<section id="report">
  <div #embeddedReport style="height: 100vh"></div>
</section>